import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_FEATURE_GROUP: FeatureGroup = {
  guid: '3b0e2366-8be8-4fec-8220-2c16edaeff00',
  name: 'development',
  description: 'Development tools — internal apps used to build and configure other Altru integrations',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
